export const thankyou = {
  eyebrow: "Confirmación",
  title: "¡Gracias por su interés!",
  subtitle: "Hemos recibido su información correctamente.",
  body: "Uno de nuestros analistas revisará su suscripción y le enviará por correo electrónico el próximo informe sobre el mercado de recursos naturales de Argentina. Mientras tanto, puede seguir explorando nuestros contenidos sobre litio, hidrocarburos y minería estratégica.",
  what_next_title: "Qué sigue",
  what_next_1: "Recibirá un correo de confirmación en las próximas horas.",
  what_next_2: "El próximo boletín se publica cada martes por la mañana.",
  what_next_3: "Puede darse de baja en cualquier momento desde cualquier envío.",
  back_home: "Volver al inicio",
  contact_label: "¿Consultas?",
  contact_value: "contacto@xorvyniq.com"
};
